import { createDialog } from '@patsnap/tahiti-core';
export function createRequestExportPaperOptionsService() {
    return createDialog(() => import('../../components/ExportPaperDialog.vue'));
}
